<template>
  <div class="hero-header-wrapper">
    <div class="hero-header">
      <!-- Background Layer -->
      <div class="hero-bg" :style="backgroundStyle">
        <div class="hero-overlay"></div>
        <div class="hero-pattern"></div>
      </div>

      <!-- Content -->
      <div class="hero-content">
        <div class="hero-container">
          <!-- Breadcrumb -->
          <div class="hero-breadcrumb">
            <div class="breadcrumb-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 9.5L12 4L21 9.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 13V19.4C19 19.7314 18.7314 20 18.4 20H5.6C5.26863 20 5 19.7314 5 19.4V13"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Portal del Cliente</span>
            </div>
            <svg
              class="breadcrumb-separator"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9 6L15 12L9 18"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div
              :class="[
                'breadcrumb-item',
                { 'breadcrumb-current': !selectedProperty },
                { 'breadcrumb-clickable': selectedProperty },
              ]"
              @click="goToProperties"
            >
              <span>{{ menuTitle }}</span>
            </div>
            <template v-if="selectedProperty">
              <svg
                class="breadcrumb-separator"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 6L15 12L9 18"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="breadcrumb-current">{{ selectedProperty.title }}</div>
            </template>
          </div>

          <!-- Main Hero Content -->
          <div class="hero-main">
            <div class="hero-text">
              <h1 class="hero-title">
                <span class="title-greeting">Hola,</span>
                <span class="title-name">{{
                  user.name ? user.name.split(" ")[0] : "Usuario"
                }}</span>
              </h1>
              <p class="hero-subtitle">
                {{
                  headerText ||
                  "Bienvenido a tu espacio. Aquí podrás gestionar tus casos y pagar tus cuotas con facilidad."
                }}
              </p>
            </div>
          </div>

          <!-- Quick Actions -->
          <div class="hero-actions">
            <a @click="goToProperties" class="action-btn primary">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 9.5L12 4L21 9.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 13V19.4C19 19.7314 18.7314 20 18.4 20H5.6C5.26863 20 5 19.7314 5 19.4V13"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Mis Casos</span>
            </a>
            <router-link
              v-if="showMyData"
              :to="{ name: 'information' }"
              class="action-btn secondary"
              @click.native="scrollToTop"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="8"
                  r="4"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M5 20C5 16.6863 7.68629 14 11 14H13C16.3137 14 19 16.6863 19 20"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
              <span>Mi Perfil</span>
            </router-link>

            <!-- Economic Indicators -->
            <div class="hero-indicators" v-if="country == 1">
              <div class="indicators-card">
                <div class="indicators-header">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 3V21H21"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 14L12 9L16 13L21 8"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>Indicadores del día</span>
                </div>
                <div class="indicators-list">
                  <div class="indicator-item">
                    <span class="indicator-label">UF</span>
                    <span class="indicator-value">{{
                      indicators.uf || "---"
                    }}</span>
                  </div>
                  <div class="indicator-item">
                    <span class="indicator-label">UTM</span>
                    <span class="indicator-value">{{
                      indicators.utm || "---"
                    }}</span>
                  </div>
                  <div class="indicator-item">
                    <span class="indicator-label">USD</span>
                    <span class="indicator-value">{{
                      indicators.dolar || "---"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Decorative Elements -->
      <div class="hero-decoration">
        <div class="decoration-circle circle-1"></div>
        <div class="decoration-circle circle-2"></div>
        <div class="decoration-circle circle-3"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      user: this.$auth.user(),
      indicators: {
        uf: null,
        utm: null,
        dolar: null,
      },
      selectedProperty: null,
    };
  },
  mounted() {
    this.fetchIndicators();
    // Listen for property selection events
    this.$root.$on("property-selected", this.onPropertySelected);
  },
  beforeDestroy() {
    this.$root.$off("property-selected", this.onPropertySelected);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onPropertySelected(propertyInfo) {
      this.selectedProperty = propertyInfo;
    },
    goToProperties() {
      this.scrollToTop();
      // If we're on the index route and have a selected property, go back to grid
      if (this.$route.name === "index" && this.selectedProperty) {
        this.$root.$emit("go-back-to-grid");
      } else {
        // Otherwise, navigate to the index route
        this.$router.push({ name: "index" });
      }
    },
    async fetchIndicators() {
      try {
        // API de mindicador.cl para indicadores económicos de Chile
        const response = await fetch("https://mindicador.cl/api");
        const data = await response.json();

        this.indicators = {
          uf: this.formatCurrencyDecimal(data.uf?.valor),
          utm: this.formatCurrency(data.utm?.valor),
          dolar: this.formatCurrency(data.dolar?.valor),
        };
      } catch (error) {
        console.error("Error fetching indicators:", error);
      }
    },
    formatCurrency(value) {
      if (!value) return null;
      return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);
    },
    formatCurrencyDecimal(value) {
      if (!value) return null;
      return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
  },
  computed: {
    backgroundStyle() {
      if (this.background) {
        return {
          backgroundImage: `url(${this.background})`,
        };
      }
      return {};
    },
    menuTitle() {
      switch (this.$route.name) {
        case "information":
          return "Mi Perfil";
        case "quote":
          return "Cotizar";
        case "myquotes":
          return "Mis Cotizaciones";
        case "index":
          return "Mis Casos";
        case "opportunities":
          return "Oportunidades";
        default:
          return "Inicio";
      }
    },
    background() {
      return require(`@/assets/images/background/${this.$store.getters.getSite}/login.jpg`);
    },
    headerText() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.header_text
        : null;
    },
    customer() {
      return this.$store.getters.getCustomer;
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
    opportunitiesPermission() {
      if (this.$store.getters.getCustomerData) {
        return this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Oportunidades"
        ) && this.$store.getters.getCustomerData.show_opportunity
          ? true
          : false;
      } else {
        return false;
      }
    },
    showMyData() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_my_data
        : false;
    },
  },
};
</script>

<style scoped>
/* ===== Header Wrapper ===== */
.hero-header-wrapper {
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 24px 24px 0 24px;
  box-sizing: border-box;
}

/* ===== Hero Header Premium ===== */
.hero-header {
  /* Variables dinámicas basadas en el tema de la inmobiliaria */
  --header-bg: var(--color-header, #1e3a5f);
  --header-bg-light: color-mix(in srgb, var(--header-bg) 70%, white 30%);
  --theme-primary: var(--color-btn, #3b82f6);
  --theme-primary-text: var(--color-btn-text, #ffffff);

  position: relative;
  min-height: 320px;
  border-radius: 24px;
  overflow: hidden;
  background: linear-gradient(
    135deg,
    var(--header-bg) 0%,
    var(--header-bg-light) 50%,
    var(--header-bg) 100%
  );
  animation: heroFadeIn 0.6s ease;
}

@keyframes heroFadeIn {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Background */
.hero-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: var(--header-bg);
  opacity: 0.88;
}

.hero-overlay::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.05) 50%,
    rgba(0, 0, 0, 0.2) 100%
  );
}

.hero-pattern {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
      circle at 20% 80%,
      rgba(255, 255, 255, 0.03) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(255, 255, 255, 0.03) 0%,
      transparent 50%
    );
}

/* Content */
.hero-content {
  position: relative;
  z-index: 2;
  padding: 35px;
}

.hero-container {
  max-width: 100%;
}

/* Breadcrumb */
.hero-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 32px;
  animation: breadcrumbSlide 0.4s ease 0.2s backwards;
}

@keyframes breadcrumbSlide {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.875rem;
  font-weight: 500;
}

.breadcrumb-item.breadcrumb-clickable {
  cursor: pointer;
  transition: color 0.2s ease;
}

.breadcrumb-item.breadcrumb-clickable:hover {
  color: rgba(255, 255, 255, 0.9);
}

.breadcrumb-separator {
  color: rgba(255, 255, 255, 0.3);
}

.breadcrumb-current {
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
}

/* Main Content */
.hero-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  margin-bottom: 32px;
}

.hero-text {
  flex: 1;
  max-width: 600px;
}

.hero-title {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.title-greeting {
  font-size: 1.125rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 0.5px;
  animation: titleFadeUp 0.5s ease 0.3s backwards;
}

.title-name {
  font-size: 2.75rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -1px;
  line-height: 1.1;
  animation: titleFadeUp 0.5s ease 0.4s backwards;
}

@keyframes titleFadeUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  max-width: 500px;
  animation: subtitleFadeIn 0.5s ease 0.5s backwards;
}

@keyframes subtitleFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Indicators Header */
.indicators-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.6875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.indicators-list {
  display: flex;
  gap: 16px;
}

.indicator-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.indicator-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
}

.indicator-value {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #ffffff;
  font-variant-numeric: tabular-nums;
}

/* Actions */
.hero-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: end;
  animation: actionsFadeIn 0.4s ease 0.6s backwards;
}

@keyframes actionsFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-indicators {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
  height: 46px;
  box-sizing: border-box;
}

/* Indicators - with title on top */
.indicators-card {
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  box-sizing: border-box;
}

.action-btn.primary {
  background: #ffffff;
  color: var(--header-bg);
}

.action-btn.primary:hover {
  background: #f0f4f8;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  text-decoration: none;
  color: var(--header-bg);
}

.action-btn.secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.action-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  text-decoration: none;
  color: #ffffff;
}

/* Decorations */
.hero-decoration {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.03);
}

.circle-1 {
  width: 400px;
  height: 400px;
  top: -200px;
  right: -100px;
}

.circle-2 {
  width: 300px;
  height: 300px;
  bottom: -150px;
  left: -100px;
}

.circle-3 {
  width: 200px;
  height: 200px;
  top: 50%;
  right: 20%;
  transform: translateY(-50%);
}

/* Responsive */
@media (max-width: 1024px) {
  .hero-header-wrapper {
    padding: 16px 16px 0 16px;
  }
}

@media (max-width: 992px) {
  .hero-header {
    min-height: auto;
    margin: 0;
  }

  .hero-content {
    padding: 32px 24px;
  }

  .hero-main {
    flex-direction: column;
    gap: 24px;
  }

  .hero-indicators {
    margin-left: 0;
    width: 100%;
  }

  .indicators-card {
    width: 100%;
  }

  .indicators-list {
    width: 100%;
    justify-content: space-between;
  }

  .title-name {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .hero-header-wrapper {
    padding: 12px 12px 0 12px;
  }
}

@media (max-width: 576px) {
  .hero-header {
    margin: 0;
    border-radius: 20px;
  }

  .hero-breadcrumb {
    display: none;
  }

  .hero-content {
    padding: 24px 20px;
  }

  .title-name {
    font-size: 1.75rem;
  }

  .hero-subtitle {
    font-size: 0.875rem;
  }

  .hero-actions {
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
    justify-content: center;
    height: auto;
  }

  .hero-indicators {
    width: 100%;
  }

  .indicators-card {
    width: 100%;
  }
}
</style>
